import { Navigate, Route } from "react-router";
import { pageWith } from "@routes/routeModule";
import {
  PROGRAM,
  PROGRAMS,
  PROGRAM_COPY,
  PROGRAM_DAYS,
  PROGRAM_DIET_EDIT,
  PROGRAM_DIET_EDIT_PRODUCTS,
  PROGRAM_DIET_EDIT_RECIPES,
  PROGRAM_DIET_EDIT_SETTINGS,
  PROGRAM_DIET_EDIT_TAGS,
  PROGRAM_DIET_NEW,
  PROGRAM_EDIT,
  PROGRAM_NEW,
  PROGRAM_SCHEDULE,
  PROGRAM_SCHEDULE_RECIPE_EDIT,
} from "@routes/routes";
import {
  DietCreatorPage,
  DietCreatorProductsPage,
  DietCreatorRecipesPage,
  DietCreatorSettingsPage,
  DietCreatorTagsPage,
  PatientProgramDaysPage,
  ProgramCopyPage,
  ProgramDietsNewPage,
  ProgramEditPage,
  ProgramCreatorBootstrapPage,
  ProgramSettingsPage,
  ProgramAssumptionsPage,
  ProgramRecipesPage,
  ProgramMealPlanPage,
  ProgramCreatorSchedulePage,
  ProgramPage,
  ProgramLayout,
  ProgramsPage,
  ScheduleRecipeEditPage,
  PatientProgramDay,
} from "@routes/lazyPages";

export const programRoutes = (
  <>
    <Route path={PROGRAM_NEW} lazy={ProgramCreatorBootstrapPage} />
    <Route path={PROGRAM_EDIT} lazy={ProgramEditPage}>
      <Route index element={<Navigate to="settings" replace />} />
      <Route path="settings" lazy={ProgramSettingsPage} />
      <Route path="assumptions" lazy={ProgramAssumptionsPage} />
      <Route path="recipes" lazy={ProgramRecipesPage} />
      <Route path="meal-plan" lazy={ProgramMealPlanPage} />
      <Route path="schedule" lazy={ProgramCreatorSchedulePage} />
    </Route>
    <Route
      path={PROGRAM_DAYS}
      lazy={pageWith(
        () => import("@Programs/creator/ProgramCreatorLegacyRedirectPage"),
        { step: "assumptions" },
      )}
    />
    <Route
      path={PROGRAM_SCHEDULE}
      lazy={pageWith(
        () => import("@Programs/creator/ProgramCreatorLegacyRedirectPage"),
        { step: "meal_plan" },
      )}
    />
    <Route lazy={ProgramLayout}>
      <Route path={PROGRAM_COPY} lazy={ProgramCopyPage} />
      <Route path={`${PROGRAM_DAYS}/:dayId`} lazy={PatientProgramDaysPage}>
        <Route index lazy={PatientProgramDay} />
      </Route>
      <Route path={PROGRAM_DIET_NEW} lazy={ProgramDietsNewPage} />

      <Route path={PROGRAM} lazy={ProgramPage} />
    </Route>

    <Route path={PROGRAMS} lazy={ProgramsPage} />
    <Route path={PROGRAM_SCHEDULE_RECIPE_EDIT} lazy={ScheduleRecipeEditPage} />

    <Route path={PROGRAM_DIET_EDIT} lazy={DietCreatorPage}>
      <Route path={PROGRAM_DIET_EDIT_SETTINGS} lazy={DietCreatorSettingsPage} />
      <Route path={PROGRAM_DIET_EDIT_RECIPES} lazy={DietCreatorRecipesPage} />
      <Route path={PROGRAM_DIET_EDIT_PRODUCTS} lazy={DietCreatorProductsPage} />
      <Route path={PROGRAM_DIET_EDIT_TAGS} lazy={DietCreatorTagsPage} />
    </Route>
  </>
);
